import useEcho from "./lib/useEcho";

function Auth() {
    const { login } = useEcho();

    return (
        <div className="flex flex-col gap-2 p-8">
            <p className="text-2xl font-medium leading-8 text-gray-200">Connect your Echo account</p>
            <p className="text-sm leading-5 text-gray-400">
                To participate in the Easy Company sale, you&apos;ll need to connect your Echo account. Create one or
                connect your existing account.
            </p>
            <button className="bg-white text-gray-800 rounded-md px-4 py-2 font-mono" onClick={login}>
                Connect account
            </button>
        </div>
    );
}

export default Auth;
